// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a671b038120f9e358689","397":"4307fada213b947dfda1"}[chunkId] + ".bundle.js";
};